module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-from-left-65849f24e05dc0946923930311456830.svg";